import * as z from "zod";

// Kept apart from the analytics contracts so the SDK can parse this response
// without bundling the agent tool schemas those contracts reference.
export const analyticsSiteDomainsResponseSchema = z.object({
  /** Every storefront domain in the project's workspace, root-domains first. */
  allDomains: z.array(z.string()),
  /** The domains the project itself publishes on — the default filter selection. */
  currentProjectDomains: z.array(z.string()),
});
